import { AppContextProps } from "../libs/app-core/AppContext";

export function OnApiError(ctx: AppContextProps, ex: any) {
  ctx.NavigateToErrorPage("", "API ERROR!", ex.message);
}